import IBookmarkState from '../interfaces/bookmarkState';
import IAction from '../interfaces/action';
import { actions } from './actions';

const initialState: IBookmarkState = {
    bookmarks: [],
    categories: [],
    noContentMessage: null,
    activeTab: 'listed-categories',
    selectedBookmarkId: '',
    selectedCategoryId: '',
    displayCreateModal: false,
    displayEditModal: false,
    displayTooltip: false,
    displayCategorizeModal: false,
    newCategoryName: '',
    editedCategoryName: '',
    editedBookmarkName: '',
    displayToastBar: false,
    toastBarType: 'info',
    toastBarMessage: '',
    displayCategorizeModalAfterCreateModal: false,
}

const reducer = (state = initialState, action: IAction): IBookmarkState => {
    let bookmarks: any[];
    let categories: any[];
    switch (action.type) {
        case actions.setNoContentMessage:
            return typeof action.payload === 'string' && action.payload.length > 0
                ? { ...state, noContentMessage: action.payload }
                : { ...state, noContentMessage: null };

        case actions.addBookmark:
            bookmarks = state.bookmarks.slice();
            bookmarks.push(action.payload);
            return {
                ...state, bookmarks
            };
        case actions.addCategory:
            categories = state.categories.slice();
            categories.push(action.payload);
            categories.sort((a, b) => {
                if (a.name && b.name) {
                    if (a.name > b.name) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
                return;
            })
            return {
                ...state, categories
            };

        case actions.deleteBookmark:
            if (!action.payload) {
                return state;
            }
            bookmarks = state.bookmarks.filter(b => b.pageId !== action.payload);
            return {
                ...state, bookmarks
            };

        case actions.populateBookmarks:
            bookmarks = action.payload;
            return {
                ...state, bookmarks
            };

        case actions.setActiveBookmarkerTab:
            return {
                ...state, activeTab: action.payload
            };

        case actions.setSelectedCategoryId:
            return {
                ...state, selectedCategoryId: action.payload
            };

        case actions.setSelectedBookmarkId:
            return {
                ...state, selectedBookmarkId: action.payload
            };

        case actions.toggleCreateModal:
            return {
                ...state, displayCreateModal: !state.displayCreateModal
            };

        case actions.toggleEditModal:
            return {
                ...state, displayEditModal: !state.displayEditModal
            };

        case actions.toggleCategorizeModal:
            return {
                ...state, displayCategorizeModal: !state.displayCategorizeModal
            };

        case actions.toggleTooltip:
            return {
                ...state, displayTooltip: !state.displayTooltip
            };

        case actions.toggleToastBar:
            return {
                ...state, displayToastBar: !state.displayToastBar
            };

        case actions.populateCategories:
            categories = action.payload;
            return {
                ...state, categories
            };

        case actions.setNewCategoryName:
            return {
                ...state, newCategoryName: action.payload
            }

        case actions.setEditedCategoryName:
            return {
                ...state, editedCategoryName: action.payload
            }

        case actions.setEditedBookmarkName:
            return {
                ...state, editedBookmarkName: action.payload
            }

        case actions.setToastBarType:
            return {
                ...state, toastBarType: action.payload
            }

        case actions.setToastBarMessage:
            return {
                ...state, toastBarMessage: action.payload
            }

        case actions.setDisplayCategorizeModalAfterCreateModal:
            return {
                ...state, displayCategorizeModalAfterCreateModal: action.payload
            }
        default:
            return state;
    }
}

export default reducer;